import React from 'react';
import { Folder } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface FolderIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const FolderIcon: React.FC<FolderIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Folder size={size} color={color} />
        </IconWrapper>
    );
};
